import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CTAButton } from 'shared-components/buttons/cta-button';

const VatCTABanner = ({
  icon,
  header,
  body,
  buttonText,
  onClickAction,
  alertState,
  primaryBtn,
  headerNotBold,
  secondaryBtnText,
  secondaryOnClickAction,
  secondaryPrimaryBtn
}) => {
  return (
    <div className={classnames('CTABanner flex column-sm border margin-xl-bottom', { alert: alertState })}>
      <div className={classnames('flex', { column: !!body })}>
        <div className={classnames('flex middle', { 'margin-md-bottom': !!body })}>
          { icon &&
              <img className="icon margin-md-right" src={`https://assets.peerspace.com/${icon}.svg?v=rb`} alt={icon} />
          }
          <span className={headerNotBold ? 'text-gray-600' : 'heavy'}>{header}</span>
        </div>

        <div className="margin-xl-right text-gray-600">
          {body}
        </div>
      </div>
      {
        buttonText && onClickAction &&
          <div className="flex middle block-md-left">
            <CTAButton
              buttonText={buttonText}
              classNameString={classnames('btn', { 'btn-primary': primaryBtn, 'btn-gray-outline': !primaryBtn })}
              onClickAction={onClickAction}
              isDisabled={ false }
            />
            {
              secondaryBtnText && secondaryOnClickAction &&
              <div className="margin-md-left">
                <CTAButton
                  buttonText={secondaryBtnText}
                  classNameString={classnames('btn', { 'btn-primary': secondaryPrimaryBtn, 'btn-gray-outline': !secondaryPrimaryBtn })}
                  onClickAction={secondaryOnClickAction}
                  isDisabled={ false }
                />
              </div>
            }
          </div>
      }
    </div>
  );
};

VatCTABanner.propTypes = {
  bannerObject: PropTypes.object,
  icon: PropTypes.string,
  onClickAction: PropTypes.func,
  alertState: PropTypes.bool,
  headerIsBold: PropTypes.bool
};

export default VatCTABanner;
